import React from "react";

import { EmptyState, UnavailableTablesNotice } from "./AdminAnalyticsCards";
import AdminAnalyticsTabs from "./AdminAnalyticsTabs";
import { aa, getErrorCopy } from "./adminAnalyticsUtils";

const RANGE_OPTIONS = [1, 7, 30, 90];

export default function AdminAnalyticsShell({
  days,
  onDaysChange,
  tabs,
  activeTabId,
  onTabChange,
  tabState,
  onRetry,
  children,
}) {
  const errorCopy = getErrorCopy(tabState?.error);

  return (
    <div className="admin-analytics-page">
      <header className="admin-analytics-header">
        <div>
          <p className="admin-analytics-eyebrow">
            {aa("eyebrow", "Admin")}
          </p>
          <h1>{aa("dashboard_title", "Analytics")}</h1>
          <p>
            {aa(
              "subtitle",
              "Aggregated product usage, user health, and backend signals."
            )}
          </p>
        </div>
        <div
          className="admin-analytics-range"
          aria-label={aa("date_range_aria", "Date range")}
        >
          {RANGE_OPTIONS.map((option) => (
            <button
              key={option}
              type="button"
              className={days === option ? "is-active" : ""}
              aria-pressed={days === option}
              onClick={() => onDaysChange(option)}
            >
              {option === 1
                ? aa("range_one_day", "1 day")
                : aa("range_days", "{{count}} days", { count: option })}
            </button>
          ))}
        </div>
      </header>

      <AdminAnalyticsTabs
        tabs={tabs}
        activeTabId={activeTabId}
        onTabChange={onTabChange}
      />

      <main
        id={`admin-analytics-panel-${activeTabId}`}
        className="admin-analytics-tab-body"
        role="tabpanel"
        aria-labelledby={`admin-analytics-tab-${activeTabId}`}
      >
        {tabState?.isLoading ? (
          <EmptyState
            title={aa("loading_title", "Loading analytics")}
            body={aa(
              "loading_body",
              "Fetching this admin analytics section."
            )}
          />
        ) : tabState?.error ? (
          <EmptyState
            title={errorCopy.title}
            body={errorCopy.body}
            actionLabel={aa("retry", "Retry")}
            onAction={onRetry}
          />
        ) : (
          <>
            <UnavailableTablesNotice tables={tabState?.data?.unavailableTables} />
            {children}
          </>
        )}
      </main>
    </div>
  );
}
